module.exports = __webpack_public_path__ + "img/Main-Page-FoodSafety-Still.c02f9610.jpg";